import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "road"
const RoadIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.038 4.726a1 1 0 0 1 1.924.548l-4 14a1 1 0 0 1-1.924-.548zm8.688-.688a1 1 0 0 1 1.236.688l4 14a1 1 0 0 1-1.924.548l-4-14a1 1 0 0 1 .688-1.236M11 18v-2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0m0-5v-2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0m0-5V6a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0" />
        </svg>
      }
    </span>
  )
}
export default RoadIcon
